import { Api } from "../config/request";
export default {
  getSubIssueTypesList(body) {
    return Api.post(`/logistics_support/sub_issue_types`, body);
  },
  getSubIssueTypesDetails(subIssueTypesId) {
    return Api.get(`/logistics_support/sub_issue_types/${subIssueTypesId}`);
  },
  saveUpdateSubIssueTypes(actionType, body) {
    if (actionType === "create") {
      return Api.post("/logistics_support/save_sub_issue_type", body);
    } else {
      return Api.put("/logistics_support/update_sub_issue_type", body);
    }
  },
  getSubIssueTypesListRemoteSearch(startsWith, page) {
    return Api.get(`/sub-issue-types?page=${page}&startswith=${startsWith}`);
  },
};
